/* tslint:disable */
/* eslint-disable */
/**
 * TOM YARD SERVICE API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from '../configuration'
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios'
import globalAxios from 'axios'
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
  replaceWithSerializableTypeIfNeeded,
} from '../common'
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  type RequestArgs,
  BaseAPI,
  RequiredError,
  operationServerMap,
} from '../base'
// @ts-ignore
import type { CreateRoadNodeRequest } from '../model'
// @ts-ignore
import type { CreateRoadNodeResponse } from '../model'
// @ts-ignore
import type { DeleteRoadNodeRequest } from '../model'
// @ts-ignore
import type { GetRoadNodesResponse } from '../model'
// @ts-ignore
import type { RoadNodeType } from '../model'
// @ts-ignore
import type { UpdateRoadNodeRequest } from '../model'
/**
 * RoadNodesApi - axios parameter creator
 */
export const RoadNodesApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {CreateRoadNodeRequest} [createRoadNodeRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createRoadNode: async (
      createRoadNodeRequest?: CreateRoadNodeRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/yard/api/RoadNodes`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        createRoadNodeRequest,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {DeleteRoadNodeRequest} [deleteRoadNodeRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteRoadNode: async (
      deleteRoadNodeRequest?: DeleteRoadNodeRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/yard/api/RoadNodes`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        deleteRoadNodeRequest,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {RoadNodeType} [type]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getRoadNodes: async (
      type?: RoadNodeType,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/yard/api/RoadNodes`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      if (type !== undefined) {
        localVarQueryParameter['type'] = type
      }

      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {UpdateRoadNodeRequest} [updateRoadNodeRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateRoadNode: async (
      updateRoadNodeRequest?: UpdateRoadNodeRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/yard/api/RoadNodes`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateRoadNodeRequest,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * RoadNodesApi - functional programming interface
 */
export const RoadNodesApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = RoadNodesApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @param {CreateRoadNodeRequest} [createRoadNodeRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createRoadNode(
      createRoadNodeRequest?: CreateRoadNodeRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateRoadNodeResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.createRoadNode(
        createRoadNodeRequest,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['RoadNodesApi.createRoadNode']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {DeleteRoadNodeRequest} [deleteRoadNodeRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteRoadNode(
      deleteRoadNodeRequest?: DeleteRoadNodeRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.deleteRoadNode(
        deleteRoadNodeRequest,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['RoadNodesApi.deleteRoadNode']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {RoadNodeType} [type]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getRoadNodes(
      type?: RoadNodeType,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetRoadNodesResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getRoadNodes(type, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['RoadNodesApi.getRoadNodes']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {UpdateRoadNodeRequest} [updateRoadNodeRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateRoadNode(
      updateRoadNodeRequest?: UpdateRoadNodeRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateRoadNode(
        updateRoadNodeRequest,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['RoadNodesApi.updateRoadNode']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * RoadNodesApi - factory interface
 */
export const RoadNodesApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = RoadNodesApiFp(configuration)
  return {
    /**
     *
     * @param {CreateRoadNodeRequest} [createRoadNodeRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createRoadNode(
      createRoadNodeRequest?: CreateRoadNodeRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<CreateRoadNodeResponse> {
      return localVarFp
        .createRoadNode(createRoadNodeRequest, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {DeleteRoadNodeRequest} [deleteRoadNodeRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteRoadNode(
      deleteRoadNodeRequest?: DeleteRoadNodeRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .deleteRoadNode(deleteRoadNodeRequest, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {RoadNodeType} [type]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getRoadNodes(
      type?: RoadNodeType,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<GetRoadNodesResponse> {
      return localVarFp.getRoadNodes(type, options).then(request => request(axios, basePath))
    },
    /**
     *
     * @param {UpdateRoadNodeRequest} [updateRoadNodeRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateRoadNode(
      updateRoadNodeRequest?: UpdateRoadNodeRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .updateRoadNode(updateRoadNodeRequest, options)
        .then(request => request(axios, basePath))
    },
  }
}

/**
 * RoadNodesApi - object-oriented interface
 */
export class RoadNodesApi extends BaseAPI {
  /**
   *
   * @param {CreateRoadNodeRequest} [createRoadNodeRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public createRoadNode(
    createRoadNodeRequest?: CreateRoadNodeRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return RoadNodesApiFp(this.configuration)
      .createRoadNode(createRoadNodeRequest, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {DeleteRoadNodeRequest} [deleteRoadNodeRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public deleteRoadNode(
    deleteRoadNodeRequest?: DeleteRoadNodeRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return RoadNodesApiFp(this.configuration)
      .deleteRoadNode(deleteRoadNodeRequest, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {RoadNodeType} [type]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public getRoadNodes(type?: RoadNodeType, options?: RawAxiosRequestConfig) {
    return RoadNodesApiFp(this.configuration)
      .getRoadNodes(type, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {UpdateRoadNodeRequest} [updateRoadNodeRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public updateRoadNode(
    updateRoadNodeRequest?: UpdateRoadNodeRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return RoadNodesApiFp(this.configuration)
      .updateRoadNode(updateRoadNodeRequest, options)
      .then(request => request(this.axios, this.basePath))
  }
}
